module.exports = __webpack_public_path__ + "img/waterImg.04850bb5.png";